import { search } from '../../Foundation';

export class ProductTree {
    /**
    * Creates an instance where user can manipulate with a textfield (number)
    * @param {HTMLElement} element input element
    */
    constructor (element) {
        // Name, reference
        element.ProductTree = this;

        // Elements
        this._refs = {
            links: Array.from(element.querySelectorAll('a'))
        };

        this._refs.links.forEach(item => item.addEventListener('click', this._onLinkClick.bind(this)));
        Array.from(document.querySelectorAll('.product_spot .product-deck')).forEach(e => e.addEventListener('click', () => {
            this._saveScreenPosition("category");
        }));
        this._loadScreenPosition();
        this._onFilterClick();
    }

    /**
     * onLinkClick
     * When clicks on a category in productree
     * @param {Event} e - Event interface
     */
    _onLinkClick(e) {
        this._saveScreenPosition('category');

        e.preventDefault();

        let command = e.target.getAttribute('href').replace('javascript:', '');

        if (command.startsWith('filterByCategory:')) {
            search.execute({
                'category': command.replace('filterByCategory:', '')
                // do not set 'filters', 'featurefilters' and 'phrase' - navigating categories should reset all search criteria.
                // https://dev.azure.com/gn-global-it/vs-cfa-digital-and-commercial-services-online/_workitems/edit/216065
            });
            return;
        }
    }

    _onFilterClick() {
        document.querySelectorAll('.product-filter__options li').forEach(filter => {
            filter.addEventListener('click', () => {
                this._saveScreenPosition('filter');
            });
        });

        document
          .querySelectorAll(".product-filter__list li *:not(span)")
          .forEach((filter) => {
            filter.addEventListener("click", () => {
              this._saveScreenPosition("filter");
            });
          });
    }

    _saveScreenPosition(type) {
        localStorage.setItem('scrollposition', type);
    }

    _scrollToSearch(element) {
        const elementRect = element.getBoundingClientRect();
        const navigationHeight = document
          .querySelector("header")
          .getBoundingClientRect().bottom;
        const scrollPosition = elementRect.top + window.pageYOffset - navigationHeight - 25;

        window.scrollTo({
            top: scrollPosition,
        });
    }

    _loadScreenPosition() {
        var scrollPosition = localStorage.getItem('scrollposition');

        if (scrollPosition === "category" || scrollPosition === "search" || scrollPosition === "filter") {
            this._scrollToSearch(document.querySelector(".product-title"));
            localStorage.removeItem("scrollposition");
        } else {
            window.scrollTo(0, scrollPosition);
            localStorage.removeItem("scrollposition");
        }
    }
}
